import React, { useRef } from 'react';
import { FieldRadioButton, FieldSelect, Tooltip } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import classNames from 'classnames';
import css from '../EditListingDescriptionForm.css';
import InfoIcon from '../../../icons/InfoIcon';
import { useIntl } from 'react-intl';
import {
    EXPERIENCE_LEVEL_ADVANCED,
    EXPERIENCE_LEVEL_EXPERIENCED,
    EXPERIENCE_LEVEL_VERY_EXPERIENCED,
    EXPERIENCE_LEVEL_BEGINNER,
} from '../../../marketplace-custom-config';
import { getPrefilledValueFromHorseType } from '../../../components/EditListingWizard/Helpers';
import { usePrefilledValue } from '../../../components/EditListingWizard/hooks/usePrefilledValue';
import { EDIT_LISTING_TAB_EXPERIENCE } from '../../../components/EditListingWizard/config';
import { PrefilledValueTooltip } from '../../../components/EditListingWizard/Components/PrefilledValueTooltip/PrefilledValueTooltip';

const minimumAgeOptions = Array.from({ length: 48 }, (_, i) => ({
    key: i + 12,
    label: `${i + 12} Jahre`,
}));

const maxWeightOptions = Array.from({ length: 9 }, (_, i) => {
    const key = i === 0 ? i + 40 : 40 + i * 5;
    return {
        key,
        label: `${key} kg`,
    };
});

const fieldName = 'desiredExperience';

const EditListingDescriptionPageFour = ({ form, values }) => {
    const intl = useIntl();
    const containerRef = useRef();

    const prefilledValue =
        getPrefilledValueFromHorseType({
            tab: EDIT_LISTING_TAB_EXPERIENCE,
            values,
        }) || EXPERIENCE_LEVEL_BEGINNER;

    const { showPrefilledValue } = usePrefilledValue({
        form,
        fieldName,
        prefilledValue,
    });

    return (
        <div ref={containerRef}>
            <h1 className={css.horseTypeTitle}>
                <FormattedMessage id="EditListingDescriptionForm.desiredExperienceTitle" />
            </h1>
            <p className={css.horseTypeSubTitle}>
                <FormattedMessage id="EditListingDescriptionForm.desiredExperienceSubTitle" />
            </p>

            <div className={classNames([css.radioButton, css.noBorder])}>
                {[
                    { label: EXPERIENCE_LEVEL_BEGINNER },
                    { label: EXPERIENCE_LEVEL_ADVANCED },
                    {
                        label: EXPERIENCE_LEVEL_EXPERIENCED,
                        subOptions: [1, 2, 3],
                    },
                    { label: EXPERIENCE_LEVEL_VERY_EXPERIENCED, subOptions: [1, 2, 3] },
                ].map(({ label, subOptions }) => {
                    const isPrefilledValue = showPrefilledValue && label === prefilledValue;

                    return (
                        <FieldRadioButton
                            key={label}
                            id={label}
                            form={form}
                            name={fieldName}
                            label={intl.formatMessage({
                                id: `EditListingLocationForm.toolTipLabel-${label}`,
                            })}
                            value={label}
                            validate={required(
                                intl.formatMessage({
                                    id: 'EditListingPricingForm.packagePriceRequired',
                                })
                            )}
                        >
                            {isPrefilledValue && (
                                <PrefilledValueTooltip parentContainerRef={containerRef} />
                            )}
                            <div className={css.tooltipPosition}>
                                <Tooltip
                                    id={label}
                                    parentContainerRef={containerRef}
                                    rootClassName={css.tooltipWrapper}
                                    tooltipClassName={css.tooltip}
                                    padding={0}
                                    content={
                                        <>
                                            <p>
                                                <FormattedMessage
                                                    id={`EditListingLocationForm.toolTipTitle-${label}`}
                                                />
                                            </p>
                                            <p>
                                                <FormattedMessage
                                                    id={`EditListingLocationForm.toolTipContent-${label}`}
                                                />
                                            </p>
                                            {subOptions && (
                                                <ul>
                                                    {subOptions.map(option => (
                                                        <li>
                                                            <FormattedMessage
                                                                id={`EditListingLocationForm.toolTipContent-${label}-option-${option}`}
                                                            />
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    }
                                >
                                    <InfoIcon width={18} height={18} />
                                </Tooltip>
                            </div>
                        </FieldRadioButton>
                    );
                })}
            </div>
            <FieldSelect
                id="minimumAge"
                name="minimumAge"
                placeholder="Mindestalter・Optional"
                form={form}
                className={css.fieldSelectPageFour}
                optionsList={minimumAgeOptions.map(option => ({
                    value: option.key,
                    label: option.label,
                }))}
            />
            <FieldSelect
                id="maxWeight"
                name="maxWeight"
                placeholder="Maximalgewicht・Optional"
                form={form}
                optionsList={maxWeightOptions.map(option => ({
                    value: option.key,
                    label: option.label,
                }))}
            />
        </div>
    );
};

export default EditListingDescriptionPageFour;
